<template>
  <BaseModal ref="modal" v-model="modalShow" size="lg">
    <b-overlay :show="isBusy">
      <b-table
          :busy="isBusy"
          :fields="fields"
          :items="items"
          sticky-header
          responsive
          no-border-collapse
          show-empty
        >
          <template #empty>
            <b-card class="text-center my-2 fs-5">
              Aún no se ha agregado ningún comentario
            </b-card>
          </template>

          <!--icono de carque de tabla-->
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando datos de tabla...</strong>
            </div>
          </template>
      </b-table>
    </b-overlay>

      <form
        v-permission="'karin-comentarios-vista-crear'"
        @submit.prevent="onSubmitComment"
      >
        <div class="form-group mb-3">
          <label for="name">Nuevo Comentario</label>
          <textarea class="form-control" id="name" v-model="comment">Escriba su comentario aquí</textarea>
        </div>
        <button type="submit" class="btn btn-primary" :disabled="!comment || isUploadingForm">
          <b-spinner small v-if="isUploadingForm"></b-spinner>
          Añadir
        </button>
      </form>

    </BaseModal>
</template>
<script>
import { mapActions } from 'vuex';
import { formatDateTime } from '@/plugins/complianceScripts/index.js'
import { EventNames } from '@/plugins/enums/index.js'
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
  name: 'KarinComments',

  components: { BaseModal },

  async mounted() {
    this.$eventBus.$on(EventNames.OpenModalKarinComments, async (query) => {
      this.denunciationId = query;
      await this.getAll();
      this.modalShow = true;
    });
  },

  data() {
    return {
      modalShow: false,

      isBusy: false,
      isUploadingForm: false,
      comment: null,
      denunciationId: null,

      fields: [
        { key: 'comment', label: 'Comentario' },
        { key: 'author', label: 'Creado por' },
        { key: 'creationDate', label: 'Fecha de creación', formatter: formatDateTime },
      ],
      items: [],
    }
  },

  methods: {
    ...mapActions(["allCommentsKarinDenunciation", "addCommentKarinDenunciation"]),

    async onSubmitComment() {
      this.isUploadingForm = true;
      let result = await this.addCommentKarinDenunciation({
        denunciationId: this.denunciationId,
        comment: this.comment
      })

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, 'danger');
        this.isUploadingForm = false;
        return;
      }

      this.$refs.modal.showAlert('Comentario agregado correctamente', 'success');
      await this.getAll();
      this.comment = null;
      this.isUploadingForm = false;
    },

    async getAll() {
      this.cargandoTabla();
      let result = await this.allCommentsKarinDenunciation({ denunciationId: this.denunciationId });

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, 'danger');
        this.cargandoTabla();
        return;
      }

      this.items = result.data;
      this.cargandoTabla();
    },

    cargandoTabla() {
      this.isBusy = !this.isBusy;
    },
  }

}
</script>
<style></style>
